module.exports = __webpack_public_path__ + "img/za.7dae6471.svg";